/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const NotificationBold = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M10.146 3.24799C10.2954 2.8787 10.5517 2.56244 10.882 2.33976C11.2124 2.11707 11.6017 1.99811 12 1.99811C12.3984 1.99811 12.7877 2.11707 13.118 2.33976C13.4483 2.56244 13.7046 2.8787 13.854 3.24799C15.3328 3.65467 16.6371 4.53554 17.5668 5.75532C18.4964 6.9751 19 8.46633 19 9.99998V14.697L20.832 17.445C20.9325 17.5956 20.9902 17.7706 20.999 17.9515C21.0078 18.1323 20.9673 18.3121 20.8819 18.4718C20.7965 18.6314 20.6693 18.7648 20.514 18.8579C20.3587 18.9509 20.1811 19 20 19H15.465C15.3446 19.8331 14.9281 20.5949 14.2917 21.1459C13.6554 21.6969 12.8418 22.0002 12 22.0002C11.1583 22.0002 10.3447 21.6969 9.70833 21.1459C9.07197 20.5949 8.65543 19.8331 8.53503 19H4.00003C3.81898 19 3.64133 18.9509 3.48602 18.8579C3.33071 18.7648 3.20356 18.6314 3.11815 18.4718C3.03274 18.3121 2.99227 18.1323 3.00106 17.9515C3.00984 17.7706 3.06755 17.5956 3.16803 17.445L5.00003 14.697V9.99998C5.00003 6.77598 7.18003 4.05999 10.146 3.24799Z"
        fill="#242425"
      />
    </BaseSvgIcon>
  )
}

export default NotificationBold
